import React from 'react'
import Navbar from './components/Navbar'
import Home from './components/Home'
import AboutUs from './components/AboutUs'
import Why from './components/Why'
import Programs from './components/Programs'
import Footer from './components/Footer'
import Menu from './components/Menu'
import Testimonials from './components/Testimonials'


function App() {
  return (
    <div>
      <Navbar />
      <Home />
      <AboutUs />
      <Why />
      <Programs />
      <Menu />
      <Testimonials />
      <Footer />
    </div>
  )
}

export default App